<template>
    <div
        v-if="isMobile"
        class="mobile_header"
        :class="{ mobile_header_not_loged: !$store.state.current_user.user_uuid }"
    >
        <ChatLogo />
        <div class="right-header">
            <div id="checkClick2" class="mobile_notification">
                <div class="log-buttons flex-center2" v-if="$store.state.current_user.user_uuid == false">
                    <router-link to="../login">
                        <div class="flex-center">Log in</div>
                    </router-link>
                    <router-link :to="{ name: 'Home' }">
                        <div class="flex-center bgc-brown color-black">Sign up</div>
                    </router-link>
                </div>
                <!-- <router-link v-if="messageLink" :to="{ name: 'ChatInner', params: { id: idt } }">
                    <div class="message-desktop message-div flex-center">
                        <img src="@/assets/publicProfile_icons/message.svg" alt="" />
                       
                    </div>
                </router-link> -->
                <Notifications />
            </div>
            <div v-if="$store.state.current_user.user_uuid" class="menu-button flex-center" @click="toggleSidebar">
                <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="0.832031" y1="1.09729" x2="23.0774" y2="1.09729" stroke="#FFC695" />
                    <line x1="0.832031" y1="8.48926" x2="23.0774" y2="8.48926" stroke="#FFC695" />
                    <line x1="0.832031" y1="15.8812" x2="23.0774" y2="15.8812" stroke="#FFC695" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import Notifications from "@/components/Notification/Notifications";
import ChatLogo from "./Chatroom/ChatLogo.vue";

export default {
    name: "MobileHeader",
    components: { ChatLogo, Notifications },
    props: ["isSidebarOpen", "idt"],
    data() {
        return {
            isMobile: false,

            messageLink: false,
        };
    },
    mounted() {
        if (window.location.href.split("/").pop() == "1") {
            this.messageLink = true;
        }

        //  console.log(window.innerWidth);
        if (window.innerWidth < 500) {
            this.isMobile = true;
        }
    },
    methods: {
        toggleSidebar() {
            this.$emit("toggleSidebarParent");
        },
    },
};
</script>

<style scoped lang="scss">
.mobile_header {
    display: none;
}

.right-header {
    display: flex;
}
// .message-desktop {
//     width: 40px;
//     height: 40px;
//     img {
//         width: 40px;
//         height: 40px;
//     }
//     right: 120px;
//     position: relative;
// }

.menu-button {
    padding-right: 1.5rem;
}

@media screen and (max-width: 1024px) {
    .mobile_header {
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding: 0.85rem 0 0.85rem 2.547rem;
        background-color: #171819;
        border-bottom: 1px solid rgba(111, 115, 129, 0.2);
    }
    .mobile_header_not_loged {
        padding: 0.85rem 0 0.85rem 1.5rem;
    }

    .mobile_notification {
        display: flex;
        align-items: flex-end;
        margin-right: 1.5rem;
        div {
            color: white;
        }
    }
    .log-buttons {
        div {
            height: 36px;
            width: 100px;
            margin-left: 15px;
            border-radius: 6px;
            border: 1px solid #c8a07d;

            font-size: 14px;
            font-weight: 600;
        }
    }
}
</style>
